// FIN-8011: textos do design da página de oferta indisponível.
// Sempre em português, inclusive no Peru.
export const OFFER_UNAVAILABLE_TEXTS = {
  notStarted: {
    title: 'As vendas desta oferta ainda não começaram',
    message:
      'Recebemos seus dados. Quando as vendas abrirem, você poderá comprar por este mesmo link.',
  },
  closed: {
    title: 'As vendas desta oferta foram encerradas',
    message:
      'Recebemos seus dados. Se quiser conhecer outras opções, fale com a nossa equipe.',
  },
  paymentClosed: {
    title: 'As vendas desta oferta foram encerradas',
    message: 'Seu pagamento não foi concluído e nenhum valor foi cobrado.',
  },
  // FIN-8119 (D08): produto esgotado. Copy provisória, sem tela no FIN-8122
  // conferida: confirmar com o design.
  soldOut: {
    title: 'As vagas desta oferta esgotaram',
    message:
      'Recebemos seus dados. Se quiser conhecer outras opções, fale com a nossa equipe.',
  },
  /** Recusa com PLAN_SOLD_OUT. */
  paymentSoldOut: {
    title: 'As vagas desta oferta esgotaram',
    message: 'Seu pagamento não foi concluído e nenhum valor foi cobrado.',
  },
  /**
   * Recusa com PLAN_SALES_NOT_STARTED ou SALES_COUNT_UNAVAILABLE (FIN-8119) e
   * motivo ausente ou desconhecido.
   */
  generic: {
    title: 'Esta oferta não está disponível no momento',
    message:
      'Recebemos seus dados e nenhum valor foi cobrado. Para saber mais, fale com a nossa equipe.',
  },
} as const;

// FIN-8011/FIN-8239: textos do design do contador e das vagas restantes.
export const OFFER_COUNTDOWN_TEXTS = {
  label: 'Encerra em',
  limitedBadge: 'Oferta limitada',
} as const;

export const OFFER_REMAINING_SLOTS_TEXTS = {
  /** Faixa do topo: "Resta" + "1 vaga" ou "Restam" + "N vagas". */
  barLabel: (remainingSlots: number) =>
    remainingSlots === 1 ? 'Resta' : 'Restam',
  /** Card do resumo: "Vaga restante" + "1" ou "Vagas restantes" + "N". */
  summaryLabel: (remainingSlots: number) =>
    remainingSlots === 1 ? 'Vaga restante' : 'Vagas restantes',
  /** "1 vaga" no singular, "N vagas" nos demais. */
  slots: (remainingSlots: number) =>
    remainingSlots === 1 ? '1 vaga' : `${remainingSlots} vagas`,
} as const;

// FIN-8268: boleto desabilitado nos últimos dias de venda da oferta.
export const OFFER_BOLETO_CUTOFF_TEXTS = {
  disabledReason:
    'Indisponível nos últimos dias de venda. Selecione outro método de pagamento.',
  // Oferta só com boleto depois do corte: não há outro método para sugerir.
  onlyBoletoUnavailable:
    'O boleto não está mais disponível nos últimos dias de venda desta oferta.',
} as const;
